import React, { useState } from "react";
import {
    FaBars,
    FaTimes,
    FaFileDownload,
    FaSignOutAlt,
    FaBookOpen,
    FaChartBar,
    FaFileUpload
} from "react-icons/fa";

import "./adminsidebar.css";

function AdminSidebar({ active, setActive }) {

    const [mobileOpen, setMobileOpen] = useState(false);
    

    return (
        <>
            {/* Mobile Header */}
            <div className="mobile-header">
                <FaBars onClick={() => setMobileOpen(true)} />
                <span>Admin Menu</span>
            </div>

            {/* Overlay */}
            {mobileOpen && (
                <div
                    className="overlay"
                    onClick={() => setMobileOpen(false)}
                ></div>
            )}

            {/* Sidebar */}
            <div className={`sidebar ${mobileOpen ? "open" : ""}`}>

                {/* Close Button */}
                <div className="close-btn">
                    <FaTimes onClick={() => setMobileOpen(false)} />
                </div>

                {/* Header */}
                <div className="sidebar-header">

                    <img
                        src="/ASTU_JMEE_JLEE/img/astulogo.png"
                        alt="ASTU"
                    />

                    <h3>ASTU ADMIN</h3>

                    <p>JMEE & JLEE Portal</p>

                    <span>
                        Assam Science and Technology University
                    </span>

                </div>

                <div className="sidebar-divider"></div>

                <div className="section-title">
                    ADMIN PANEL
                </div>

                {/* Dashboard */}
                <div
                    className={`item ${active === "instruction" ? "active" : ""}`}
                    onClick={() => setActive("instruction")}
                >
                    <FaBookOpen className="icon" />
                    Instructions
                </div>

                <div
                    className={`item ${active === "analyticaldashboard" ? "active" : ""}`}
                    onClick={() => setActive("analyticaldashboard")}
                >
                    <FaChartBar className="icon" />
                    Analytical Dashboard
                </div>

                <div
                    className={`item ${active === "download" ? "active" : ""}`}
                    onClick={() => setActive("download")}
                >
                    <FaFileDownload className="icon" />
                    Download Data
                </div>

                <div
                    className={`item ${active === "uploadpdf" ? "active" : ""}`}
                    onClick={() => setActive("uploadpdf")}
                >
                    <FaFileUpload className="icon" />
                    Upload PDF'S
                </div>

               






                

              

                <div className="sidebar-divider"></div>

                {/* Logout */}
                <div
                    className="item logout-btn"
                    onClick={() => {
                        sessionStorage.clear();
                        window.location.href = "/ASTU_JMEE_JLEE/AdminLogin";
                    }}
                >
                    <FaSignOutAlt />
                    <span>Logout</span>
                </div>

                {/* Footer */}
                <div className="sidebar-footer">
                    ASTU © 2026-27
                </div>

            </div>
        </>
    );
}

export default AdminSidebar;